/**
 * Returns config removing debug if env is production.
 * @param config
 */
export var stripDebugOptionsIfProd = function stripDebugOptionsIfProd(configs) {
  if (process.env.CHEGG_ENV === 'prod') {
    delete configs.debug;
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/utils/DebugUtils.js
// module id = 4369
// module chunks = 11